import {
    EventType,
    FormInitializer,
    FormBinding, FormLoadAndRenderParams,
    FormLoadParams
} from '../types';
import {getInitializer} from './initializerRegistry';
import {FormLoaderError, PAGE_TYPE_FORM} from '@bff/loader-utils';
import {loadAndMountForm} from '../internal/loadAndMountForm';

export async function loadAndRender(loadAndRenderFormParams: FormLoadAndRenderParams): Promise<FormBinding> {
    if (!loadAndRenderFormParams.container) {
        throw new FormLoaderError('A container element is required to render a form', 404);
    }
    const formInitializer = await load(loadAndRenderFormParams);

    const formBinding = await formInitializer(loadAndRenderFormParams.container);

    const { eventHandlers } = loadAndRenderFormParams;
    if (eventHandlers) {
        (Object.keys(eventHandlers) as EventType[]).forEach((eventName) => {
            const handler = eventHandlers[eventName];
            if (handler) {
                const event = formBinding.events[eventName];
                if (!event) {
                    throw new FormLoaderError(`Invalid event handler provided: ${eventName}`, 404);
                }
                event.subscribe(handler);
            }
        });
    }

    formBinding.render(loadAndRenderFormParams.pageType || PAGE_TYPE_FORM);
    return formBinding;
}

export async function load(loadAndRenderFormParams: FormLoadParams): Promise<FormInitializer> {
    const key = {
        network: loadAndRenderFormParams.network,
        property: loadAndRenderFormParams.property,
        pageId: loadAndRenderFormParams.pageId
    };
    let formInitializer = getInitializer(key);

    if (!formInitializer) {
        await loadAndMountForm(loadAndRenderFormParams);

        formInitializer = getInitializer(key);
        if (!formInitializer) {
            throw new FormLoaderError(`Initializer not found for key: ${key.network}:${key.property}:${key.pageId}`, 500);
        }
    }
    return formInitializer;
}
